const toList = (value) => value.replace(/\s+/g, "").split(",");

export default toList;
